import Phaser from 'phaser';

import { CardViewModel } from './card-view-model';
import { BlackjackMainScene } from '../../scenes/blackjack-main-scene';
import { ResizeMetrics } from '../../model/resize-metrics';

export class CardBackView extends Phaser.GameObjects.Container {
  private cardBack: Phaser.GameObjects.Image;

  constructor(
    scene: BlackjackMainScene,
    x: number,
    y: number,
    private viewModel: CardViewModel,
  ) {
    super(scene, x, y);

    this.cardBack = scene.add.image(0, 0, viewModel.cardBackAsset.type).setOrigin(0.5, 0.5);
    this.add(this.cardBack);

    this.setName(CardBackView.name);
    scene.add.existing(this);
  }

  public onResize(resizeMetrics: ResizeMetrics): void {
    const cardScaleFactor = resizeMetrics.scalingMetrics.scaleFactor * 0.8;

    const asset = this.viewModel.cardBackAsset;
    this.cardBack.setDisplaySize(
      asset.dimensions.width * cardScaleFactor,
      asset.dimensions.height * cardScaleFactor,
    );
  }
}
